var React = require('react');

function ShareWhite (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#FFF","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M5 10.774v8.18C5 20.085 5.784 21 6.75 21h10.5c.966 0 1.75-.916 1.75-2.045v-8.18M12 4v10.226M16 7.375l-4-4-4 4"})));
}

ShareWhite.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ShareWhite;

ShareWhite.default = ShareWhite;
